import { routes } from '../../../constants';
import {
	infographicQuality,
	infographicRent,
	infographicAtex,
} from '../../../assets/images/images';

export const INDUSTRIAL_CONFIG = {
	infographic: [
		{
			title: 'INDUSTRIAL.QUALITY_WORK',
			img: infographicQuality,
			description: 'INDUSTRIAL.QUALITY_WORK_BODY',
			url: routes.INDUSTRIAL.CUSTOMIZATION,
		},
		{
			title: 'INDUSTRIAL.RENT',
			img: infographicRent,
			description: 'INDUSTRIAL.RENT_BODY',
			url: routes.INDUSTRIAL.RENT,
		},
		{
			title: 'INDUSTRIAL.ATEX',
			img: infographicAtex,
			description: 'INDUSTRIAL.ATEX_BODY',
			url: routes.INDUSTRIAL.ATEX,
		},
	],

};



// WEBPACK FOOTER //
// ./src/components/organisme/industrial/industrial.config.js